export default __webpack_public_path__ + "static/media/balance2.2293c0fe.png";